import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function takeawayReducer(state = initialState.takeaway, action){
    switch(action.type){
      case types.GET_TAKEAWAY_DETAILS_SUCCESS:
        return ({...state, response:action.takeaways});
      case types.SET_CUSTOM_TAKEAWAYS:
        return({...state,response:action.customTakeaways});
      case types.SET_DESIGN_TAKEWAYS:
        return({...state, designs:action.designs})
      default:
      return state;
    }
}
